










































































































































































































































































































































































































































import Vue from "vue";
import BaseModalWindow from "@/app/shared/components/base/BaseModalWindow.vue";
import BaseSearchInput from "@/app/shared/components/base/BaseSearchInput.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import { $eventsBus } from "@/main";
import { EndCard } from "../../models/classes/end-card/EndCard";
import _ from "lodash";
import { EndCardAPI } from "@/app/modules/work/services/EndCardAPI";

export default Vue.extend({
  name: "EndCardLibraryWindow",
  components: { BaseModalWindow, BaseSearchInput, BaseButton },
  data: function () {
    return {
      packshots: [],
      packshotsTemplateDefault: [],
      isLoadingVideoPackshot: true,
      isLoadingTemplatesDefaultPackshot: true,
      filteredVideoPackshots: [],
      filteredTemplateDefaultPackshots: [],

      selectedPackshot: null,

      searchValue: "",
      searchSizes: [],
      tab: "video",
      conformityTabType: {
        video: ["video"],
        template: ["template-default", "template-custom"],
        "template-default": ["template-default"],
        "template-custom": ["template-custom"],
      },
    };
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    selectedVariationsSizes: function () {
      let sizes = [];
      if (this.previewItem.currentVariation.checked) {
        this.$store.state.items
          .reduce((acc, val) => acc.concat(val.variations), [])
          .filter((v) => v.checked)
          .forEach((v) => {
            let currentSize = v.currentSize.name.toUpperCase();
            if (sizes.indexOf(currentSize) === -1) {
              sizes.push(currentSize);
            }
          });
      } else {
        sizes.push(
          this.previewItem.currentVariation.currentSize.name.toUpperCase()
        );
      }
      return sizes;
    },
  },
  created() {
    // Возможно нужно фиксить, как и в OverlayLibraryWindow
    if (this.previewItem.currentVariation.endCard.packshot) {
      this.tab = Object.keys(this.conformityTabType).find((key) =>
        this.conformityTabType[key].includes(
          this.previewItem.currentVariation.endCard.packshot.type
        )
      );
      if (this.tab === "template") {
        this.tab = "template-default";
      }
    }
  },
  mounted() {
    this.selectedPackshot = this.previewItem.currentVariation.endCard.packshot;
    this.searchSizes = this.selectedVariationsSizes.slice();
    this.updateLibraryVideoPackshot();
    this.updateLibraryTemplatesDefaultPackshot();
    $eventsBus.$emit("muteMainContent", true);
    this.updateAllItemsVariationsPackshots();
  },
  watch: {},
  methods: {
    showListLabelTemplateDefault(packshot) {
      const labels = Object.entries(packshot.list);
      return labels.filter((label) => label[1] !== false);
    },
    clickSize(size) {
      if (this.searchSizes.includes(size)) {
        this.searchSizes.splice(this.searchSizes.indexOf(size), 1);
      } else {
        this.searchSizes.push(size);
      }
      this.search(this.searchValue);
    },
    updateAllItemsVariationsPackshots() {
      this.items.forEach((item) => {
        let isHasEndCardsToDelete = false;
        item.variations.forEach((variation) => {
          if (!variation.endCard.packshot) {
            return;
          } else {
            let updatedPackshot = this.packshots.find(
              (p) => p.packId === variation.endCard.packshot.packId
            );
            if (updatedPackshot) {
              variation.endCard.packshot = updatedPackshot;
              variation.recalcFileOutputParameters();
            }
          }
        });
      });
    },
    checkAllItemsVariationsPackshotsWithThisId(packId) {
      let itemsCount = 0;
      let variationsCount = 0;
      let variationsWithEndCardToDelete = [];
      let message = "";
      this.items.forEach((item) => {
        let isHasEndCardsToDelete = false;
        item.variations.forEach((variation) => {
          if (
            variation.endCard.packshot &&
            variation.endCard.packshot.packId === packId
          ) {
            isHasEndCardsToDelete = true;
            variationsCount++;
            variationsWithEndCardToDelete.push(variation);
          }
        });
        itemsCount += isHasEndCardsToDelete ? 1 : 0;
      });
      message =
        "In " +
        itemsCount +
        " video items in " +
        variationsCount +
        " variations, the End Card will be removed. Continue?";
      if (itemsCount > 0) {
        let isDelete = confirm(message);
        if (isDelete) {
          variationsWithEndCardToDelete.forEach((v) => {
            v.endCard.packshot = null;
            v.recalcFileOutputParameters();
          });
        }
        return isDelete;
      } else {
        return true;
      }
    },
    updateLibraryVideoPackshot() {
      this.isLoadingVideoPackshot = true;
      this.axios
        .post(
          "/packshots/getVideos",
          {
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          response.data.forEach((packshot) => {
            this.packshots.push({ ...packshot, type: "video" });
          });
          this.search(this.searchValue);
        })
        .finally(() => {
          this.isLoadingVideoPackshot = false;
        });
    },
    updateLibraryTemplatesDefaultPackshot() {
      this.isLoadingTemplatesDefaultPackshot = true;
      this.axios
        .post(
          "/packshots/getLottiesPackshots",
          {
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          response.data.forEach((packshot) => {
            this.packshotsTemplateDefault.push({
              ...packshot,
              type: "template-default",
            });
          });
          this.search(this.searchValue);
        })
        .finally(() => {
          this.isLoadingTemplatesDefaultPackshot = false;
        });
    },
    filterVideoBySizes() {
      this.filteredVideoPackshots =
        this.searchSizes.length === 0
          ? this.filteredVideoPackshots
          : this.filteredVideoPackshots.filter((p) =>
              this.searchSizes.some((s) => this.isVideoPackshotHasSize(p, s))
            );
    },
    filterTemplateDefaultBySizes() {
      this.filteredTemplateDefaultPackshots =
        this.searchSizes.length === 0
          ? this.filteredTemplateDefaultPackshots
          : this.filteredTemplateDefaultPackshots.filter((p) =>
              this.searchSizes.some((s) =>
                this.isTemplateDefaultPackshotHasSize(p, s)
              )
            );
    },
    sortBySize() {
      let currentSize =
        this.previewItem.currentVariation.currentSize.name.toUpperCase();
      this.filteredVideoPackshots.sort((a, b) => {
        return this.isVideoPackshotHasSize(a, currentSize) &&
          !this.isVideoPackshotHasSize(b, currentSize)
          ? -1
          : 1;
      });
    },
    search(value) {
      this.searchValue = value;
      if (this.searchValue === "") {
        this.filteredVideoPackshots = this.packshots;
        this.filteredTemplateDefaultPackshots = this.packshotsTemplateDefault;
      } else {
        this.filteredVideoPackshots = this.packshots.filter(
          (p) => p.name.toLowerCase().indexOf(this.searchValue) !== -1
        );

        this.filteredTemplateDefaultPackshots =
          this.packshotsTemplateDefault.filter((p) => {
            return p.name.toLowerCase().indexOf(this.searchValue) !== -1;
          });
      }
      this.filterVideoBySizes();
      this.filterTemplateDefaultBySizes();
      this.sortBySize();
    },
    closeWindow() {
      this.selectedPackshot = null;
      $eventsBus.$emit("muteMainContent", false);
      this.$emit("close");
    },
    saveChanges() {
      if (!this.selectedPackshot) {
        return;
      }
      if (
        !this.isPackshotHasAllSizes(
          this.selectedPackshot,
          this.selectedVariationsSizes
        )
      ) {
        return;
      }
      if (this.selectedPackshot.type === "video") {
        this.previewItem.currentVariation.endCard.packshot =
          this.selectedPackshot;
        this.setVideoForCheckedItems();
        $eventsBus.$emit("updatePackshotAfterChanges");
        this.previewItem.currentVariation.recalcFileOutputParameters();
      } else if (this.selectedPackshot.type === "template-default") {
        this.getTemplatePackhot(
          this.previewItem.currentVariation,
          this.selectedPackshot,
          this.previewItem.currentVariation.currentSize.name
        ).then(() => {
          $eventsBus.$emit("updatePackshotAfterChanges");
          this.previewItem.currentVariation.recalcFileOutputParameters();
        });
        this.setTemplateDefaultForCheckedItems();
      }
      //TODO check not null packshots
      this.closeWindow();
    },
    async getTemplatePackhot(variation, selectedPackshot, size) {
      const packshot = _.cloneDeep(selectedPackshot);

      variation.isLoadingPackshot = true;

      return await EndCardAPI.getTemplatePackhot(selectedPackshot, size)
        .then((response) => {
          const { model, audio, json } = response.data;
          variation.endCard.packshot = packshot;
          variation.endCard.packshot.model = model;
          variation.endCard.packshot.audio = audio;
          variation.endCard.packshot.json = json;
        })
        .finally(() => {
          variation.isLoadingPackshot = false;
        });
    },
    changeTemplatePackshot() {},
    setVideoForCheckedItems() {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      this.items.forEach((item) => {
        item.variations.forEach((v) => {
          if (!v.checked || v === this.previewItem.currentVariation) {
            return;
          }

          v.endCard.packshot =
            this.previewItem.currentVariation.endCard.packshot;
          v.recalcFileOutputParameters();
        });
      });
    },
    setTemplateDefaultForCheckedItems() {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      this.items.forEach((item) => {
        item.variations.forEach(async (v) => {
          if (!v.checked || v === this.previewItem.currentVariation) {
            return;
          }
          await this.getTemplatePackhot(
            v,
            this.selectedPackshot,
            v.currentSize.name
          ).then();
          v.recalcFileOutputParameters();
        });
      });
    },
    onAddNewFile() {
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };
      const route = "/packshots/createPack";
      this.axios
        .post(
          route,
          { sessionId: this.$store.state.userInfo.sessionId },
          config
        )
        .then((res) => {
          let newEndCard = {
            packId: res.data.packId,
            name: res.data.name,
            list: [],
          };
          this.onEditPackshot(newEndCard);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    isPackshotFileSelected(packshot) {
      return (
        (packshot.type === "video" &&
          this.isVideoPackshotFileSelected(packshot)) ||
        (packshot.type === "template-default" &&
          this.isTemplateDefaultPackshotFileSelected(packshot))
      );
    },
    isVideoPackshotFileSelected(packshot) {
      return this.selectedPackshot?.packId === packshot.packId;
    },
    isTemplateDefaultPackshotFileSelected(packshot) {
      return this.selectedPackshot?.packId === packshot.packId;
    },
    onEditPackshot(packshot) {
      $eventsBus.$emit("openEndCardEditWindow", packshot);
    },
    onDeletePackshot(packshot) {
      let isDelete = this.checkAllItemsVariationsPackshotsWithThisId(
        packshot.packId
      );
      if (!isDelete) {
        return;
      }
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };
      let route = "/packshots/setSettings";
      this.axios
        .post(
          route,
          {
            id: packshot.packId,
            name: packshot.name,
            settings: {
              s: -1,
              f: -1,
              h: -1,
              v: -1,
              p: -1,
            },
            sessionId: this.$store.state.userInfo.sessionId,
          },
          config
        )
        .then((res) => {
          if (
            this.previewItem.currentVariation.endCard.packshot?.packId ===
            packshot.packId
          ) {
            this.previewItem.currentVariation.endCard.packshot = null;
            this.previewItem.currentVariation.recalcFileOutputParameters();
          }
          let indexToDelete = this.packshots.indexOf(packshot);
          this.packshots.splice(indexToDelete, 1);
          this.search(this.searchValue);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onClickButton(packshot) {
      if (this.isPackshotHasAllSizes(packshot, this.selectedVariationsSizes)) {
        this.selectedPackshot = packshot;
      }
    },
    isVideoPackshotHasSize(packshot, sizeName) {
      return Object.entries(packshot.list)
        .map((e) => e[0].toLowerCase())
        .includes(sizeName.toLowerCase());
    },
    isTemplateDefaultPackshotHasSize(packshot, sizeName) {
      return Object.entries(packshot.list)
        .filter((label) => label[1] !== false)
        .map((e) => e[0].toLowerCase())
        .includes(sizeName.toLowerCase());
    },
    isPackshotHasAllSizes(packshot, sizes) {
      return (
        (packshot.type === "video" &&
          this.isVideoPackshotHasAllSizes(packshot, sizes)) ||
        (packshot.type === "template-default" &&
          this.isTemplateDefaultPackshotHasAllSizes(packshot, sizes))
      );
    },
    isVideoPackshotHasAllSizes(packshot, sizes) {
      return sizes.every((s) => this.isVideoPackshotHasSize(packshot, s));
    },
    isTemplateDefaultPackshotHasAllSizes(packshot, sizes) {
      return sizes.every((s) =>
        this.isTemplateDefaultPackshotHasSize(packshot, s)
      );
    },
    formatSize(sizeName) {
      switch (sizeName.toUpperCase()) {
        case "S":
          return "1:1";
          break;
        case "F":
          return "4:5";
          break;
        case "P":
          return "2:3";
          break;
        case "V":
          return "9:16";
          break;
        case "H":
          return "16:9";
          break;

        default:
          return sizeName.toUpperCase();
          break;
      }
    },
  },
});
